import React, { useEffect } from 'react';
import style from './LoginHistory.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLoginHistory } from '../../../actions/loginhistory.action';
import { Oval } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';

const LoginHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allLoginHistory = useSelector(
    (state) => state.getAllLoginHistoryReducer
  );

  const { data, success, loading } = allLoginHistory;

  useEffect(() => {
    dispatch(getAllLoginHistory());
  }, [dispatch]);

  const handleUser = (id) => {
    navigate(`/admin/user/${id}`);
  };

  return (
    <>
      <h1 style={{ color: 'rgb(206, 144, 206)' }}>Login History</h1>
      <div className={style.LoginHistory}>
        {loading ? (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        ) : data && data.length !== 0 ? (
          <div>
            <div className={style.TableHead}>
              <div>Date</div>
              <div>User</div>
              <div>IP</div>
              <div>Location</div>
              <div>Browser</div>
              <div>OS</div>
            </div>
            <div>
              {data
                .slice(0)
                .reverse()
                .map((his) => {
                  let date = new Date(his.createdAt).toString();
                  const result = date.split(' ');
                  const newDate = `${result[2]}/${result[1]}/${result[3]}`;
                  const newTime = result[4];

                  return (
                    <div className={style.TableData} key={his._id}>
                      <div className={style.TimeDate}>
                        <div className={style.Date}>{newDate}</div>
                        <div
                          className={style.Time}
                        >{`Time - ${newTime}`}</div>
                      </div>
                      <div
                        className={style.UserClick}
                        onClick={() => handleUser(his.user?._id || his.user)}
                      >
                        {his.user?.name || his.user}
                      </div>
                      <div>{his.loginHistory.ip}</div>
                      <div>{`${his.loginHistory.location}-${his.loginHistory.country}`}</div>
                      <div>{his.loginHistory.browserName}</div>
                      <div>{his.loginHistory.os}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          <div className={style.Center} style={{ fontWeight: '500' }}>
            No login history found!
          </div>
        )}
      </div>
    </>
  );
};

export default LoginHistory;
